
import { Component, OnInit, ViewChild, Inject, Input } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator } from '@angular/material';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { MatDialog ,MatDialogRef , MAT_DIALOG_DATA } from '@angular/material';
import { NewSurveyerDialogComponent } from '../newSurveyerDialog/new-surveyer-dialog.component'
import { LoaderService } from '../shared/services/loader.service'
import { NoManagerService } from '../shared/services/no-manager.service'
import { isUndefined,isNullOrUndefined } from "util";
import { NewManagerDialogComponent } from './new-manager'
import { TabsDataService } from '../shared/services/tabs-data.service';
import { ShowToastyService } from 'app/shared/services/showToastyService';
declare var amplitude:any;


@Component({
  selector: 'manager-data',
  templateUrl: './manager.component.html',
  styleUrls: ['./manager.component.css']
})

export class ManagerSurveyComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  newManagerDialogRef: any;
  displayedColumns = ['Name', 'email', 'Status', 'Actions'];
  exampleDatabase: ExampleDatabase;
  dataSource: ExampleDataSource | null;
  newSurveyerDialogRef: any;
  deleteAlertDialogRef: any;
  // showDelete:boolean;
  checkedRows: string[];
  showLoader: boolean = true;
  noManagerCreated: boolean = true;
  user: string;
  @Input() managerData;


  displayedColumns2: string[] = ['userId', 'password', 'action'];
  dataSource2 : {userId:string,password:string,action:string}[] = [];
  constructor(public restApiService: RestApiService, public dialog: MatDialog, 
    public loaderService: LoaderService, public noManagerService: NoManagerService, 
    public tabsDataService:TabsDataService,private toastyService:ToastyService, 
    private toastyConfig: ToastyConfig, private showToastyService: ShowToastyService) {

    this.loaderService.setLoader(true);
    this.loaderService.getLoader().subscribe(message => {
       if (message != null) { this.showLoader = message }
    });
    this.noManagerService.setNoManager(false);
    this.noManagerService.getNoManager().subscribe(message => { 
      if (message != null)
       { this.noManagerCreated = message } 
      });
  }

  ngOnInit() {
    this.loaderService.setLoader(true);
    this.tabsDataService.setSuperAdminManagerTabDataTobeUpdated(true);
    this.tabsDataService.setSurveyTabDataTobeUpdated(true);
    this.tabsDataService.setTeamsTabDataTobeUpdated(true);
    this.tabsDataService.setSurveyorDataTobeUpdated(true);
    this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService,this.noManagerService,this.tabsDataService);
    this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
    this.user = localStorage.getItem("username");
  }
  showManagerInfo = true;
  ngOnChanges(){
    this.dataSource2 = [];
    if(this.managerData){
      this.managerData.forEach(data=>{
        this.dataSource2.push({userId:data.email,password:"*******",action:"action"});
      })
    }
  }
  resetPassword(row){
    const email = row.userId;
    this.restApiService.forgotPasswordService(email).subscribe(
      result => {
        if (result.success) {
          this.showToastyService.success('Success' , 'Reset password link was successfully sent to manager - ' + row.email);
        }
        else {
          this.showToastyService.success('Failed' , result.value);
        }
      })
  }

  openAddManagerDialog() {
    amplitude.getInstance().logEvent('Add Manager Button clicked');

    this.newManagerDialogRef = this.dialog.open(NewManagerDialogComponent, {
      height: '400px',
      width: '800px',
    });

    this.newManagerDialogRef.afterClosed().subscribe(result => {

      if(result.success)
      {
        this.loaderService.setLoader(true);
        this.tabsDataService.setSuperAdminManagerTabDataTobeUpdated(true);
        this.noManagerService.setNoManager(false);
        this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService,this.noManagerService,this.tabsDataService);
        this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
      }
    });

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  InviteManager(row) {
    if (row.action == "View Details") {
      let dialogRef = this.dialog.open(DetailsDialogComponent, {
        width: '420px',
        height: '395px',
        data:row
      });
    }
    else {
      this.restApiService.inviteManagerService(row.email).subscribe(
        result => {
          if (result.success != false) {
            // console.log(result);
            var toastOptions:ToastOptions = {
              title: "Invitation Sent",
              msg: "Invitation was successfully sent to " + row.email +'. '+result.status,
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
          }
          else {
            // this.failMsg = result.msg;
          }
        });
    }
  }

  deleteManager(row) {
    this.deleteAlertDialogRef = this.dialog.open(DeleteManagerDialogComponent, {
      data: row,
      height: '305px',
      width: '400px',
    });

    this.deleteAlertDialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined ) {
        this.loaderService.setLoader(true);
        this.tabsDataService.setSuperAdminManagerTabDataTobeUpdated(true);
        this.tabsDataService.setSurveyTabDataTobeUpdated(true);
        this.tabsDataService.setTeamsTabDataTobeUpdated(true);
        this.tabsDataService.setSurveyorDataTobeUpdated(true);
        this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService,this.noManagerService,this.tabsDataService);
        this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
      }
    });
  }

  showLoginDetails(){
    if(!this.dataSource2 || this.dataSource2.length == 0){
      let toastOptions:ToastOptions = {
        title: "",
        msg: "Please add managers to display their login details.",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.warning(toastOptions);
      return;
    }
    console.log("....",this.dataSource2, this.dataSource2.length);
    this.showManagerInfo = false
  }
}

export interface managerDetail {
  Name: string,
  email:string
}

export class ExampleDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<managerDetail[]> = new BehaviorSubject<managerDetail[]>([]);
  get data(): managerDetail[] { return this.dataChange.value; }
  restApiService: RestApiService;
  loaderService: LoaderService;
  NoManagerService: NoManagerService;
  tabsDataService:TabsDataService;

  constructor(restApiService: RestApiService, loaderService: LoaderService,  NoManagerService: NoManagerService,tabsDataService:TabsDataService) {
    // Fill up the database with 100 users.
    this.restApiService = restApiService;
    this.loaderService = loaderService;
    this.NoManagerService = NoManagerService;
    this.tabsDataService = tabsDataService;

    if(!isNullOrUndefined(this.tabsDataService.getSuperadminManagerTabData()) && !this.tabsDataService.hasSuperAdminManagerTabDataTobeUpdated())
    {
        let users = this.tabsDataService.getSuperadminManagerTabData();
        for (let i = 0; i < users.length; i++) {
          this.addUser(users[i]);
        }
        this.loaderService.setLoader(false);
        this.NoManagerService.setNoManager(false);
    }
    else{

      this.restApiService.getManagersList().subscribe(
        result => {
          // console.log(result);
          this.loaderService.setLoader(false);
          if (result == null || isUndefined(result.data)) {
            this.loaderService.setLoader(false);
          }
          else {
            if (result.data.length == 0) {
              this.NoManagerService.setNoManager(true);
              this.loaderService.setLoader(false);
            }
            else {
              let users = result.data;
              this.tabsDataService.setSuperadminManagerTabData(users);
              for (let i = 0; i < users.length; i++) {
                this.addUser(users[i]);
              }
              this.NoManagerService.setNoManager(false);
              this.tabsDataService.setSuperAdminManagerTabDataTobeUpdated(false);
            }
          }
        });
    }
  }

  /** Adds a new user to the database. */
  addUser(user) {
    const copiedData = this.data.slice();
    copiedData.push(this.createNewUser(user));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new User. */
  private createNewUser(user) {
    if (user.Status == 1) {
      user.status = 'Added';
      user.action = 'View Details';
    }
    else if (user.Status == 2 || user.Status == 3) {
      user.status = 'Invitation Sent';
      user.action = 'Send Invite';
    }
    else if (user.Status == 4) {
      user.status = 'Request Declined';
      user.action = 'Resend Invite';
    }
    else{
      user.status = 'Invitation Sent';
      user.action = 'Send Invite';
    }
    return user;
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  constructor(private _exampleDatabase: ExampleDatabase, private _paginator: MatPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<managerDetail[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._paginator.page,
      this._filterChange,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice();

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      const renderedData = data.splice(startIndex, this._paginator.pageSize);
      return renderedData.filter((item: managerDetail) => {
        let searchStr = (item.Name + item.email).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) != -1;
      });
    });
  }

  disconnect() { }
}
@Component({
  selector: 'manager-details-dialog',
  templateUrl: 'manager-details-dialog.html',
  styleUrls: ['manager-details-dialog.css']
})
export class DetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DetailsDialogComponent> , @Inject(MAT_DIALOG_DATA) public data: any){
     }
     onCancel(){
       this.dialogRef.close();
     }
}

@Component({
  selector: 'delete-manager-dialog',
  templateUrl: 'delete-manager-dialog.html',
  styleUrls: ['delete-manager-dialog.css']
})
export class DeleteManagerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteManagerDialogComponent>,public restApiService:RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNo(): void {
    this.dialogRef.close();
  }

  onYes(){
    let adminID = this.data.adminID;
    if(!this.data.adminID){
      adminID = this.data.email;
    }
    this.restApiService.removeAdminforSuperadmin(adminID).subscribe(
      result => {
        this.dialogRef.close(result.success);
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/manager/manager.component.ts